export const AmortizationTypeStringEnum = {
  Daily: 'Days',
  Monthly: 'Monthly',
  BiWeekly: 'Bi-weekly',
  Annually: 'Annually'
};
